import React from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'

/**
 * Mission section component - matching original kardstech.com design
 * Features: Mission statement, business intelligence section with dashboard mockup
 */
const Mission = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-50px" })

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.3
      }
    }
  }

  const itemVariants = {
    hidden: { 
      opacity: 0, 
      backgroundColor: 'transparent',
      border: 'none'
    },
    visible: {
      opacity: 1,
      backgroundColor: 'transparent',
      border: 'none',
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  }

  return (
    <section 
      id="mission" 
      className="relative min-h-screen overflow-hidden"
      style={{ 
        backgroundImage: `url('/mision-bg.svg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
      ref={ref}
    >
      <div className="relative min-h-screen">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          style={{ background: 'transparent' }}
        >
          {/* Our Mission Section - aligned with navigation */}
          <div 
            className="mission-section absolute top-16"
            style={{ 
              background: 'transparent',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              maxWidth: '1280px',
              paddingLeft: '16px',
              paddingRight: '16px'
            }}
          >
            <div 
              className="mission-content"
              style={{ 
                marginLeft: 'auto',
                maxWidth: '50%',
                background: 'transparent'
              }}
            >
            <motion.div 
              className="text-white"
              variants={itemVariants}
              style={{ background: 'transparent' }}
            >
              <h2 
                className="mission-title text-4xl md:text-5xl font-bold mb-4"
                style={{ 
                  fontFamily: 'Sequel100-65, sans-serif',
                  color: '#E5FF47',
                  background: 'transparent'
                }}
              >
                Our Mission
              </h2>
              <div 
                className="w-16 h-1 mb-6"
                style={{ backgroundColor: '#E5FF47' }}
              ></div>
              <p 
                className="mission-text text-xl md:text-2xl leading-relaxed"
                style={{ 
                  fontFamily: 'Poppins, sans-serif',
                  color: '#ffffff',
                  background: 'transparent'
                }}
              >
                To empower any poker club or league through the use of blockchain technology.
              </p>
            </motion.div>
            </div>
          </div>
          
          {/* Business Intelligence Section - aligned with navigation */}
          <div 
            className="business-section absolute bottom-16"
            style={{ 
              background: 'transparent',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              maxWidth: '1280px',
              paddingLeft: '16px',
              paddingRight: '16px'
            }}
          >
            <div 
              className="business-content"
              style={{ 
                marginLeft: 'auto',
                maxWidth: '50%',
                background: 'transparent'
              }}
            >
            <motion.div 
              className="text-white"
              variants={itemVariants}
              style={{ background: 'transparent' }}
            >
              <h3 
                className="business-title text-3xl md:text-4xl font-bold mb-6"
                style={{ 
                  fontFamily: 'Sequel100-65, sans-serif',
                  color: '#ffffff',
                  background: 'transparent'
                }}
              >
                Business Intelligence?
              </h3>
              <div className="space-y-4" style={{ background: 'transparent' }}>
                <p 
                  className="business-text text-lg leading-relaxed opacity-90"
                  style={{ 
                    fontFamily: 'Poppins, sans-serif',
                    background: 'transparent'
                  }}
                >
                  OlinPoker is the first platform that provides seamless data analysis leading to enhanced business intelligence. OlinPoker will automatically give you actionable insights into players performances and games. 
                </p>
                <p 
                  className="business-text text-lg leading-relaxed opacity-90"
                  style={{ 
                    fontFamily: 'Poppins, sans-serif',
                    background: 'transparent'
                  }}
                >
                  As a result, your club's profit will increase — from now on, you'll get to enjoy the convenience of detailed reporting and full business intelligence.
                </p>
              </div>
            </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Mission
